import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = [
    "form",
    "list",
    "output",
    "goalTemplate",
    "cardTemplate",
  ]

  static values = {
    goalType: Number,
    output: Array
  }

  connect () {
    this.parse()
    this.initSortable()
  }

  initSortable() {
    let sortable = new Sortable(this.listTarget, {
      handle: ".draggable",
      onEnd: (e) => {
        this.parse()
      }
    })
  }

  parse() {
    this.outputValueChanged()
  }

  outputValueChanged() {
    this.outputTarget.value = ''

    let output = []

    this.formTargets.forEach((form) => {
      const player_id = form.querySelector('select.player_id').value
      const minute_in = form.querySelector('input[name="in"]').value
      const minute_out = form.querySelector('input[name="out"]').value

      let goals = []
      const goalContainers = form.querySelectorAll('.goal')
      goalContainers.forEach((goalContainer) => {
        const goalType = goalContainer.querySelector('select.goal-type').value
        const goalMinute = goalContainer.querySelector('input.goal-minute').value
        const goalScoreHome = goalContainer.querySelector('input.goal-score-home').value
        const goalScoreAway = goalContainer.querySelector('input.goal-score-away').value
        const vsPlayer = goalContainer.querySelector('input.vs-player')?.value

        goals.push({
          type: goalType,
          min: goalMinute,
          scoreHome: goalScoreHome,
          scoreAway: goalScoreAway,
          vs_player: vsPlayer
        })
      })

      let cards = []
      const cardContainers = form.querySelectorAll('.card')
      cardContainers.forEach((cardContainer) => {
        const cardType = cardContainer.querySelector('select.card-type').value
        const cardMinute = cardContainer.querySelector('input.card-minute').value

        cards.push({
          type: cardType,
          min: cardMinute
        })
      })

      output.push({
        id: player_id,
        in: minute_in,
        out: minute_out,
        goals: goals,
        cards: cards
      })
    })

    this.outputTarget.value = JSON.stringify(output)
  }

  changeGoalType(event) {
    const goal = event.currentTarget.closest('.goal')
    const vsPlayerContainer = goal.querySelector('.vs-player-container')
    const vsPlayerInput = vsPlayerContainer.querySelector('input.vs-player')

    vsPlayerInput.value = ''

    vsPlayerContainer.classList.remove('flex')
    vsPlayerContainer.classList.add('hidden')

    if ([4, 5].includes(Number(event.currentTarget.value))) {
      vsPlayerContainer.classList.remove('hidden')
      vsPlayerContainer.classList.add('flex')
    }

    this.parse()
  }

  addForm(event) {
    event.preventDefault()

    let formNode = this.formTargets[this.formTargets.length - 1].cloneNode(true)
    const formNodeOutValue = formNode.querySelector('input[name="out"]').value

    this.listTarget.appendChild(document.importNode(formNode, true))

    const clonedFormNode = this.formTargets[this.formTargets.length - 1]
    clonedFormNode.querySelector('select.player_id').value = ''
    clonedFormNode.querySelector('input[name="out"]').value = ''
    clonedFormNode.querySelector('input[name="in"]').value = formNodeOutValue
  }

  removeForm(event) {
    event.preventDefault()

    event.currentTarget.closest('.player-form').remove()

    this.parse()
  }

  addGoal(event) {
    event.preventDefault()

    const goalTemplate = this.goalTemplateTarget.cloneNode(true)
    goalTemplate.classList.remove('hidden')
    goalTemplate.classList.add('flex')

    const goalsContainer = event.currentTarget.closest('.player-form').querySelector('.goals-container')

    goalsContainer.appendChild(goalTemplate)

    goalTemplate.querySelector('select.goal-type').value = ''
    goalTemplate.querySelector('input.goal-minute').value = ''
    goalTemplate.querySelector('input.goal-score-home').value = ''
    goalTemplate.querySelector('input.goal-score-away').value = ''

    this.parse()
  }

  removeGoal(event) {
    event.preventDefault()
    event.currentTarget.closest('.goal').remove()
    this.parse()
  }

  addCard(event) {
    event.preventDefault()

    const cardTemplate = this.cardTemplateTarget.cloneNode(true)
    cardTemplate.classList.remove('hidden')
    cardTemplate.classList.add('flex')

    const cardContainer = event.currentTarget.closest('.player-form').querySelector('.cards-container')

    cardContainer.appendChild(cardTemplate)

    cardTemplate.querySelector('select.card-type').value = 1
    cardTemplate.querySelector('input.card-minute').value = ''

    this.parse()
  }

  removeCard(event) {
    event.preventDefault()
    event.currentTarget.closest('.card').remove()
    this.parse()
  }
}
